<template>
  <v-row class="graph-header">
    <date-picker
      :text="datePickerText"
      :hover-text="hoverText"
      @update-date="handleDateUpdate"
    />
    <v-col
      cols="auto"
      class="pl-0 ml-5 d-flex align-center"
    >
      <v-btn
        id="graph-refresh"
        class="mr-3"
        text
        x-small
        fab
        @click="$emit('refresh-graph')"
      >
        <v-icon
          :class="refreshing ? 'rotate' : ''"
          size="14"
          style="margin: auto 0;"
          color="base"
        >
          $faSyncAlt
        </v-icon>
      </v-btn>
      <span class="graph-refresh__label">
        Refreshed {{ timeInt }} {{ timeInt === 1 ? "minute" : "minutes" }} ago
      </span>
    </v-col>
  </v-row>
</template>

<script>
  import DatePicker from '@/components/base/DatePicker.vue'
  import { DateTime } from 'luxon'

  const dateString = 'd LLL yyyy'
  const timeString = 'h:mma ZZZZ'
  const axesLimitsString = 'LLL d, yyyy'

  export default {
    name: 'GraphHeader',
    components: { DatePicker },
    props: {
      dates: Object,
      refreshing: Boolean,
      rangeSelected: Object,
    },
    data () {
      return { timeInt: 0, refreshInterval: null }
    },
    computed: {
      hoverText () {
        const formatDate = (date) => DateTime.fromJSDate(date).toFormat(dateString)
        const formatTime = (date) => DateTime.fromJSDate(date).toFormat(timeString)
        return {
          startDate: formatDate(this.dates.startDate),
          startTime: formatTime(this.dates.startDate),
          endDate: formatDate(this.dates.endDate),
          endTime: formatTime(this.dates.endDate),
        }
      },
      datePickerText () {
        if (this.rangeSelected.label) return this.rangeSelected.label.toUpperCase()
        const start = DateTime.fromJSDate(this.dates.startDate)
        const end = DateTime.fromJSDate(this.dates.endDate)
        return `${start.toFormat(axesLimitsString)} - ${end.toFormat(axesLimitsString)}`
      },
    },
    destroyed () {
      clearInterval(this.refreshInterval)
    },
    methods: {
      handleDateUpdate ({ dates, diff }, range) {
        this.$emit('update-date', { dates, diff }, range)
      },
      restartLastUpdated () {
        this.timeInt = 0
        clearInterval(this.refreshInterval)
        this.refreshInterval = setInterval(() => {
          this.timeInt++
        }, 60000)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .graph-header {
    background-color:$na-dark-cream;
    padding-left: 17px;
    color: $base;
    max-width:100%;
    margin:0;
    height:70px;
    display:flex;
    align-items:center;
  }
  .graph-refresh__label {
    font-size:10px;
    font-weight: 600;
    line-height:12px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
  }
  .rotate {
    animation: rotate 1s infinite linear;
  }
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
  .export-pdf {
    position: absolute;
    right: 0;
    padding-right: 20px;
  }
</style>
